import api from './api';

export const contactService = {
  // Submit contact form (public)
  async submitContact(contactData) {
    try {
      const response = await api.post('/contact-form', contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact:', error);
      throw error;
    }
  },

  // Get all contacts (admin)
  async getContacts(params = {}) {
    try {
      const response = await api.get('/blog/admin/contacts', { params });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  },

  // Get contact stats (admin)
  async getStats() {
    try {
      const response = await api.get('/blog/admin/contacts/stats');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  },

  // Get single contact (admin)
  async getContact(id) {
    try {
      const response = await api.get(`/blog/admin/contacts/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching contact:', error);
      throw error;
    }
  },

  // Update contact status (admin)
  async updateStatus(id, status) {
    try {
      const response = await api.patch(`/blog/admin/contacts/${id}`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  },

  // Delete contact (admin)
  async deleteContact(id) {
    try {
      const response = await api.delete(`/blog/admin/contacts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting contact:', error);
      throw error;
    }
  }
};

export default contactService;
